'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen'];
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNpemVzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUFlLENBQ2IsS0FEYSxFQUViLEtBRmEsRUFHYixPQUhhLEVBSWIsTUFKYSxFQUtiLE1BTGEsRUFNYixLQU5hLEVBT2IsT0FQYSxFQVFiLE9BUmEsRUFTYixNQVRhLEVBVWIsS0FWYSxFQVdiLFFBWGEsRUFZYixRQVphLEVBYWIsVUFiYSxFQWNiLFVBZGEsRUFlYixTQWZhLEVBZ0JiLFNBaEJhLEMiLCJmaWxlIjoiU2l6ZXMuanMiLCJzb3VyY2VSb290IjoiRDpcXFByb2plY3RzXFxyZWFjdC10b2Nhc1xcc3JjIn0=



//////////////////
// WEBPACK FOOTER
// ../lib/Sizes.js
// module id = 159
// module chunks = 0